//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { CHAT_PANEL_ID, CHAT_PANEL_TITLE } from './chatPanelId';
import { useChatAvailability } from './useChatAvailability';
import PanelPill from '@/components/Header/PanelPill';

/**
 * The header launcher for the chat panel: a panel pill like any other, plus
 * the one thing that is not general -- chat is unusable without a configured
 * model, so its pill is the only one that can be disabled.
 */
const AskAiPill = () => {
  const { isDisabled, disabledReason } = useChatAvailability();

  return (
    <PanelPill
      panelId={CHAT_PANEL_ID}
      label={CHAT_PANEL_TITLE}
      isDisabled={isDisabled}
      disabledReason={disabledReason}
    />
  );
};

export default AskAiPill;
